import { Component, inject } from '@angular/core';
import { ApiPoll, PagedArray, PollsApi } from '@tytapp/api';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '@tytapp/user';
import { PageComponent } from '@tytapp/common';

type ElementType<A> = A extends readonly (infer T)[] ? T : never;
const STATUSES = ['open', 'closed', 'all'] as const;
type Status = ElementType<typeof STATUSES>;

@Component({
    selector: 'tyt-petitions-per-topic',
    templateUrl: './petitions-per-topic.component.html',
    styleUrls: ['./petitions-per-topic.component.scss']
})
export class PetitionsPerTopicComponent extends PageComponent {
    private pollsApi = inject(PollsApi);
    private userService = inject(UserService);

    allPetitions: PagedArray<ApiPoll>;
    petitions: ApiPoll[];

    statuses = STATUSES;
    selectedStatus: Status = this.statuses[this.statuses.length - 1]; // can't use .at() here until we upgrade deployment Node.js

    init() {
        this.route.params.subscribe(
            async ({ slug }) => {
                this.allPetitions = await this.pollsApi.all('all', 'Petition', slug, 1).toPromise();
                this.filterPetitions();
            }
        );
    }

    filterPetitions(selectedStatus = this.selectedStatus) {
        this.selectedStatus = selectedStatus;
        // @ts-ignore Array.prototype.at
        if (selectedStatus === this.statuses.at(-1)) {
            this.petitions = this.allPetitions;
        } else {
            this.petitions = this.allPetitions.filter(
                ({ status }) => <any>selectedStatus === 'closed' ?
                    status === selectedStatus :
                    status !== 'closed'
            );
        }
    }

    get user() {
        return this.userService.user;
    }
}
